export default class MemberListModel {
  constructor(list) {
    this.list = list.map((member) => ({ value: member.id, label: member.name }));
  }

  static fromRes(data) {
    return new MemberListModel(data);
  }
}
